/**
 * Merge incoming keywords into existing ones.
 * If a keyword is already on the asset, keeps its attachedBy (including undefined / team user).
 * New keywords get attachedBy from the payload or defaultIncomingAttachedBy.
 * @param {Object[]} existingKeywords
 * @param {Object[]} incomingKeywords
 * @param {string} defaultIncomingAttachedBy - attachedBy for new keywords from incoming batch
 * @returns {Object[]}
 */
export default function mergeKeywordsPreservingSources(
  existingKeywords = [],
  incomingKeywords = [],
  defaultIncomingAttachedBy,
) {
  const existingById = new Map(existingKeywords.map((keyword) => [keyword._id, keyword]));
  const incomingIds = new Set(incomingKeywords.map(({ _id }) => _id));

  const merged = incomingKeywords.map((keyword) => {
    const existing = existingById.get(keyword._id);
    if (existing) {
      return { ...keyword, attachedBy: existing.attachedBy };
    }
    return { ...keyword, attachedBy: keyword.attachedBy || defaultIncomingAttachedBy };
  });

  existingKeywords.forEach((keyword) => {
    if (!incomingIds.has(keyword._id)) {
      merged.push(keyword);
    }
  });

  return merged;
}
